import analytics from "web/script/analytics/analytics";
import baustein from "baustein";

export default baustein.register("product-overview", {
    defaultOptions: {},

    setupEvents(add) {
        add("readMoreText", this._onReadMoreText);
    },

    _onReadMoreText() {
        analytics.event("product_overview", "read_more_details");
    },
});
